import { render } from "./MultiPositionPanel.vue?vue&type=template&id=aef45858&scoped=true&ts=true"
import script from "./MultiPositionPanel.vue?vue&type=script&lang=ts"
export * from "./MultiPositionPanel.vue?vue&type=script&lang=ts"

import "./MultiPositionPanel.vue?vue&type=style&index=0&id=aef45858&lang=scss&scoped=true"

import exportComponent from "E:\\Code\\Github\\Wuguojie-AviationTeach\\AviationTeach-PPT\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aef45858"]])

export default __exports__